import React, { useEffect } from "react";
import Card from "components/card";
import FormItem from "components/fields/FormItem";
import { Form } from 'antd';
import { connect } from "react-redux";
import { 
	getPayrunDetails
} from "../../../../redux/payrun/payrunState";


const PayrunEmployee = ({getRecord, recordData, recordId}) => {
  	
  	useEffect(() => {
        getRecord(recordId);
	}, [getRecord, recordId]);
	
  	return (
    	<Card extra={"w-full h-full p-4"}>
		  	<Form className="p-4 bg-white rounded-md dark:bg-intsamis-900"
		  		layout="vertical"
	        >   
        		<div className="grid grid-cols-4">         
		            <FormItem label="Employee ID">
		            	<label className="ps-3 dark:text-white">{recordData?.ppr_employee_code}</label>
	            	</FormItem>
	            	<FormItem label="Employee Name">
		            	<label className="ps-3 dark:text-white">{recordData?.ppr_employee_name}</label>
	            	</FormItem>
	            	<FormItem label="Payroll Cut-Off">
		            	<label className="ps-3 dark:text-white">{`${recordData?.payroll?.pay_date_from} to ${recordData?.payroll?.pay_date_to}`}</label>
	            	</FormItem>
		            <FormItem label="Status">
		            	<label className="ps-3 dark:text-white">{recordData?.ppr_status_name}</label>
	            	</FormItem>	            
	 			</div>
	 		</Form>	 	
	 	</Card>
  	);
};

const mapStateToProps = (state) => ({
  	recordData: state.payrun.payrunDetails?.data,
  	requesting: state.payroll.payrollDetails?.requesting,
});

const mapDispatchToProps = (dispatch) => ({
	getRecord: (id) => dispatch(getPayrunDetails(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PayrunEmployee);
